import { useEffect, useRef } from 'react';
import { yarnById } from '../../domain/catalogs';
import type { PatternRecord } from '../../domain/types';

/** Tiny canvas preview of a pattern's cells for the gallery. */
export function Thumbnail({ record, size = 150 }: { record: PatternRecord; size?: number }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const px = Math.max(1, Math.floor(size / Math.max(record.cols, record.rows)));
    const w = record.cols * px;
    const h = record.rows * px;
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const extra = record.palette;
    ctx.clearRect(0, 0, w, h);
    for (const [k, cell] of Object.entries(record.cells)) {
      if (!cell.color) continue;
      const y = yarnById(cell.color, extra);
      if (!y) continue;
      const [r, c] = k.split('-').map(Number);
      ctx.fillStyle = y.hex;
      ctx.fillRect(c * px, r * px, px, px);
    }
  }, [record, size]);
  return <canvas ref={ref} className="max-h-full max-w-full object-contain" style={{ imageRendering: 'pixelated' }} />;
}
